import { useState } from 'react'

export function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  )
}

export function isBeforeDay(a: Date, b: Date): boolean {
  return (
    new Date(a.getFullYear(), a.getMonth(), a.getDate()).getTime() <
    new Date(b.getFullYear(), b.getMonth(), b.getDate()).getTime()
  )
}

export function formatDate(date: Date): string {
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${m}/${d}/${date.getFullYear()}`
}

export function getCalendarDays(year: number, month: number): Date[] {
  const firstDay = new Date(year, month, 1)
  const startOffset = firstDay.getDay()
  const daysInMonth = new Date(year, month + 1, 0).getDate()
  const days: Date[] = []

  for (let i = startOffset - 1; i >= 0; i--) {
    days.push(new Date(year, month, -i))
  }
  for (let d = 1; d <= daysInMonth; d++) {
    days.push(new Date(year, month, d))
  }
  let nextDay = 1
  while (days.length < 42) {
    days.push(new Date(year, month + 1, nextDay++))
  }
  return days
}

export function useCalendar(initialDate?: Date) {
  const [viewDate, setViewDate] = useState(() => {
    const d = initialDate ?? new Date()
    return new Date(d.getFullYear(), d.getMonth(), 1)
  })

  function prevMonth() {
    setViewDate((d) => new Date(d.getFullYear(), d.getMonth() - 1, 1))
  }

  function nextMonth() {
    setViewDate((d) => new Date(d.getFullYear(), d.getMonth() + 1, 1))
  }

  function goToDate(date: Date) {
    setViewDate(new Date(date.getFullYear(), date.getMonth(), 1))
  }

  const days = getCalendarDays(viewDate.getFullYear(), viewDate.getMonth())

  return { viewDate, prevMonth, nextMonth, goToDate, days }
}
